import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/ContactUsV2/BotCard/BotCard.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/ContactUsV2/BotChannel/BotChannel.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/ContactUsV2/ContactChannelBase/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/ContactUsV2/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/usr/src/app/src/components/GlobalFooter/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/HomePage/utils/pageLoadEvent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/Product/ProductNav/headerDesktopAndMweb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/Product/ProductSchema/customSeoTags.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/UserStatsAndAppLink/UserStatsAndAppLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["getR2d2Payload"] */ "/usr/src/app/src/utils/r2d2Payload.ts");
